module.exports = new __parcel__URL__("threads.ca5154e1.png").toString();